module.exports = __webpack_public_path__ + "img/banner.f8b9a1fa.png";